	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.Node.Component;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs/ref/Node/Component.js
// module id = 6
// module chunks = 0